import type { User } from '@/@types/user'
import { Link } from '@tanstack/react-router'
import clsx from 'clsx'
import type { HTMLAttributes } from 'react'
import HoverableText from './HoverableText'
import styles from './ScreenName.module.css'
import UserProfileHoverCard, { UserProfileHoverCardProps } from './UserProfileHoverCard'

export interface ScreenNameProps extends HTMLAttributes<HTMLDivElement> {
	data: User
	variant?: 'default' | 'text'
	containerProps?: Partial<UserProfileHoverCardProps>
}

export default function ScreenName({
	data,
	variant = 'default',
	containerProps,
	className,
	...props
}: ScreenNameProps) {
	const { username, screenName, trailingIcons } = data

	const renderUsername = () => {
		if (variant === 'default') {
			return (
				<HoverableText className={styles.username}>
					<Link
						onClick={(e) => {
							e.stopPropagation()
						}}
						to="/u/$username"
						params={{
							username,
						}}
					>
						{screenName}
					</Link>
				</HoverableText>
			)
		}
		if (variant === 'text') {
			return <span className={styles.usernameText}>{screenName}</span>
		}
		return null
	}

	return (
		<UserProfileHoverCard data={data} {...containerProps}>
			<div {...props} className={clsx(styles.root, className)}>
				{renderUsername()}
				{trailingIcons && (
					<div className={styles.iconsContainer}>
						{trailingIcons.map((icon, i) => (
							<img src={icon.picUrl} key={icon.picUrl} className={styles.icon} />
						))}
					</div>
				)}
			</div>
		</UserProfileHoverCard>
	)
}
